var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrNav = function SvgIcoArrNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.625 7.787 3.718 3.718-3.718 3.718a.954.954 0 1 0 1.351 1.351l4.399-4.398a.954.954 0 0 0 0-1.352L9.976 6.426a.954.954 0 0 0-1.351 0 .975.975 0 0 0 0 1.36"
  })));
};
export default SvgIcoArrNav;